import { useEffect, useState } from "react";
import { Coordinates } from "@/components/atoms/Map/Map";

/**
 * Resolves the browser's current geolocation once (or null if unavailable/denied).
 * Used to bias address autocomplete toward the user's area and to seed map centering,
 * mirroring the mobile app's `userLocationSelector`.
 */
export const useCurrentLocation = (): Coordinates | null => {
  const [location, setLocation] = useState<Coordinates | null>(null);

  useEffect(() => {
    if (typeof navigator === "undefined" || !navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      (position) => setLocation({ lat: position.coords.latitude, lng: position.coords.longitude }),
      () => undefined,
    );
  }, []);

  return location;
};
